export default "__VITE_ASSET__fCLSjrzn__"